import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "result" }




export default /*@__PURE__*/_defineComponent({
  __name: 'DevelopmentSmokeResultsModal',
  props: {
    open: { type: Boolean },
    result: {}
  },
  emits: ["update:open", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function onClose() {
  emit("update:open", false);
  emit("close");
}

function onCopy() {
  navigator.clipboard
    ?.writeText(props.result || "")
    .catch((e: unknown) => console.warn("Copy failed", e));
}

return (_ctx: any,_cache: any) => {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Auth Smoke Test Result", -1)),
          _createElementVNode("pre", _hoisted_3, _toDisplayString(_ctx.result), 1),
          _createElementVNode("div", { class: "actions" }, [
            _createElementVNode("button", { onClick: onCopy }, "Copy"),
            _createElementVNode("button", { onClick: onClose }, "Close")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})